var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style["assigned-resources-chips-wrapper"],
        _vm.isActive
          ? _vm.$style["assigned-resources-chips-wrapper_active"]
          : "",
        _vm.isFieldDisabled("resources") && _vm.resourcesLength <= _vm.maxChips
          ? _vm.$style["cursor-default"]
          : "",
      ],
      style: { width: _vm.containerWidth + "px" },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
        mouseenter: _vm.showAssignedResourcesPopup,
        mouseleave: _vm.hideAssignedResourcesPopup,
      },
    },
    [
      _c("rolling-items", {
        key: "task-settings-assigned" + _vm.rollingItemsKey,
        attrs: {
          items: _vm.resources,
          "container-width": _vm.containerWidth,
          "max-items-show": _vm.maxChips,
          offset: _vm.singleResourceAssigned && !_vm.nameless ? 4 : -8,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("vgp-chip", {
                  key: item.id,
                  attrs: {
                    "img-url": item.avatar,
                    preset:
                      _vm.singleResourceAssigned && !_vm.nameless
                        ? "user"
                        : "avatar",
                    text:
                      _vm.singleResourceAssigned && !_vm.nameless
                        ? item.name
                        : "",
                    "is-avatar": "",
                    "txt-ellipsis": _vm.resources.length === 1,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }